﻿﻿﻿﻿﻿﻿﻿﻿﻿﻿﻿﻿﻿﻿﻿﻿﻿﻿﻿﻿﻿﻿﻿﻿﻿﻿import { createRouter, createWebHashHistory } from 'vue-router'
import ProductInput from '@/components/ProductInput.vue'
import ProductList from '@/components/ProductList.vue'
import PurchaseRecord from '@/components/PurchaseRecord.vue'
import SalesRecord from '@/components/SalesRecord.vue'
import StockManagement from '@/components/StockManagement.vue'
import ProfitCalculation from '@/components/ProfitCalculation.vue'
import RestockNotice from '@/components/RestockNotice.vue'
import CashierDesk from '@/components/CashierDesk.vue'
import BatchProductEntry from '@/components/BatchProductEntry.vue'
import DashBoard from '@/components/DashBoard.vue'
import TransactionStats from '@/components/TransactionStats.vue';
import ProfitRanking from '@/components/ProfitRanking.vue'
import PrintSettings from '@/components/PrintSettings.vue'
const routes = [
    { path: '/', 
    name: '/DashBoard' ,
    component:DashBoard
}, // 让首页默认进入可视化页面

    {
        path: '/product-input',
        name: 'ProductInput',
        component: ProductInput
    },
    {
        path: '/product-list',
        name: 'ProductList',
        component: ProductList
    },
    {
        path: '/purchase-record',
        name: 'PurchaseRecord',
        component: PurchaseRecord
    },
    {
        path: '/sales-record',
        name: 'SalesRecord',
        component: SalesRecord
    },
    {
        path: '/stock-management',
        name: 'StockManagement',
        component: StockManagement
    },
    {
        path: '/profit-calculation',
        name: 'ProfitCalculation',
        component: ProfitCalculation
    },
    {
        path: '/restock-notice',
        name: 'RestockNotice',
        component: RestockNotice,
      },
    {
        path:'/Cashier-Desk',
        name:'CashierDesk',
        component:CashierDesk
    },
    {
        path:'/BatchProduct-Entry',
        name:'BatchProductEntry',
        component:BatchProductEntry
    },

    {
        path: '/transaction-stats',
        name: 'TransactionStats',
        component: TransactionStats
    },
    {
    path: '/profit-ranking',
    name: 'ProfitRanking',
    component: ProfitRanking,
    meta: { title: '利润排行' }
  },
  {
    path: '/print-settings',
    name: 'PrintSettings',
    component: PrintSettings,
    meta: { title: '打印设置' }
  }

]

const router = createRouter({
    history: createWebHashHistory(),
    routes
})

export default router
